import { useMutation, useQueryClient } from "react-query";
import apiEndPoints from "services/apiEndPoints";
import makeApiRequest from "services/makeApiRequest";
import { SuccessToast, ErrorToast } from "services/toasterService";

export default function useHrApplyLeave(closeModal, reset) {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.HR_APPLY_EMPLOYEE_LEAVE_API,
        data,
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        closeModal();
        reset({});
        SuccessToast({ text: data?.message });
        queryClient.invalidateQueries("get-employee-leaves-in-admin");
        queryClient.invalidateQueries("get-all-Applied-leaves-for-admin");
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    },
  );
}
